import styles from "./typography.module.css"

import React from "react"
import cx from "classnames"

export const Header = ({children, customStyles, className = "header"}) => <div className={cx(customStyles, styles[className])}>{children}</div>

export const Text = ({className = "text", children}) => <div className={styles[className]}>{children}</div>

export const Label = ({children}) => <div className={styles["label"]}>{children}</div>

export const Subtitle = ({children}) => <div className={styles["subtitle"]}>{children}</div>

export const BzIcon = ({className, onClick, ...props}) => <i className={cx(styles["bz"], className && styles[className])} onClick={onClick} {...props} />

export const BzIconPro = ({className, onClick, disabled, ...props}) => (
  <i className={cx(styles["bz-pro"], className && styles[className], disabled && styles["disabled"])} onClick={onClick} {...props} />
)
